import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import topIcon from '@svb/svbbranding/dist/assets/icons/arrow-top-white.svg';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const ScrollTopButton = (props) => {
  const {
    top = '300',
    scrollText = 'Top',
    dataTestId = 'scroll-top-btn',
    classes = '',
    scrollicon = <img src={topIcon} alt="scroll top icon" />
  } = props;
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY >= top);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [top]);

  const finalClass = `
  ${classes || ''}
  scroll-top-btn
  svb-button_small
  svb-button_primary-default
  gap-2
  py-3
  px-4
  h-auto
  d-flex
  align-items-center
  border-0
`.trim();

  if (!visible) return null;

  return (
    <button
      type='button'
      data-testid={dataTestId}
      className={finalClass}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      {scrollicon} {scrollText}
    </button>
  );
};

export { ScrollToTop, ScrollTopButton };
